import { Image, Wrapper } from './vendor_logo.styles';

import { VENDOR_BUSINESS_NAME } from '../../constants';

import saladStoryLogo from '../../static/saladstory-mono.svg';

type VendorLogoProps = { width?: number };

export default function VendorLogo({ width = 180 }: VendorLogoProps) {
  const height = width * (90 / 366);

  return (
    <Wrapper>
      <Image width={width} height={height} src={saladStoryLogo} alt={VENDOR_BUSINESS_NAME} />
    </Wrapper>
  );
}
